import {CompetitionStatus} from './CompetitionStatus';

export class CompetitionDto {
  constructor(
    public id: number,
    public name: string,
    public description: string,
    public startDate: string | Date | null,
    public endDate: string | Date,
    public createdByNotionUserId: string,
    public participantNotionUserIds: string[],
    public password: string,
    public status: CompetitionStatus,
    public inviteToken: string,
    public isPrivate: boolean,
    public featured?: boolean,
    // Present on every competition read since backend #317 (2026-09-07);
    // older backends or cached payloads may omit it, so readers must
    // tolerate `undefined` and render nothing rather than a fallback
    // number.
    public participantCount?: number
  ) {
  }
}
